import { useTranslation } from 'react-i18next'

const MONTH_NAMES_PL = [
	'sty',
	'lut',
	'mar',
	'kwi',
	'maj',
	'cze',
	'lip',
	'sie',
	'wrz',
	'paź',
	'lis',
	'gru',
]

export default function UnsettledMonthsList({
	months,
	year,
	month,
	onSelect,
}) {
	const { t } = useTranslation()
	const items = Array.isArray(months) ? months : []

	if (items.length === 0) {
		return (
			<div className="rounded-lg border border-gray-200 bg-white px-4 py-3 text-sm text-gray-500 shadow-sm">
				{t('rozliczenia.details.unsettledMonthsEmpty')}
			</div>
		)
	}

	return (
		<div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 shadow-sm">
			<p className="text-xs font-semibold uppercase tracking-wide text-amber-900">
				{t('rozliczenia.details.unsettledMonthsLabel')}
			</p>
			<div className="mt-2 flex flex-wrap gap-2">
				{items.map(item => {
					const isActive = item.year === year && item.month === month
					const label = `${MONTH_NAMES_PL[item.month - 1] || item.month} ${item.year}`

					return (
						<button
							key={`${item.year}-${item.month}`}
							type="button"
							onClick={() => onSelect(item.year, item.month)}
							className={[
								'rounded-md px-2.5 py-1 text-sm font-medium transition-colors',
								isActive
									? 'bg-amber-700 text-white'
									: 'bg-white text-amber-950 ring-1 ring-amber-300 hover:bg-amber-100',
							].join(' ')}
						>
							{label}
						</button>
					)
				})}
			</div>
		</div>
	)
}
